import { useEffect, useState } from "react";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import "./top-listing-headers.css";
import ActionMenu from "../../actionMenus/action-menu";
import { GetImages } from "../../../utils/GetImages";
import { ConfirmationPopup } from "../../confirmation-popup/confirmation-popup-demo";
import { sortOptionsAlphabeticallyOtherLast } from "../../../utils/helper";

interface ListingTopHeaderProps {
  PageHeading: string;
  ButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleSelectChange: any;
  filterOptions?: { title: string; count: number }[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  aggregateValuesFilters?: Record<string, number>;
  disabled: boolean,
  onDisconnect?: () => void;
  connectedEmail?: string;
  hasWritePermission?: boolean;
  hideSecondaryFilter?: boolean;
}

export default function EmailListingTopHeader({
  PageHeading,
  ButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleSelectChange,
  activeTab,
  setActiveTab,
  filterOptions = [], // default fallback
  aggregateValuesFilters,
  disabled,
  onDisconnect,
  connectedEmail,
  hasWritePermission = true,
  hideSecondaryFilter = false,
}: ListingTopHeaderProps) {
  const [secondaryFilters, setSecondaryFilters] = useState<
    { title: string; count: number }[]
  >([]);

  const [showConfirmation, setShowConfirmation] = useState(false);




  const handleDisconnectClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDisconnect = () => {
    // Call the parent function to trigger the API
    if (onDisconnect) {
      onDisconnect();
    }
    setShowConfirmation(false);
  };

  useEffect(() => {
    if (aggregateValuesFilters) {
      const options = Object.entries(aggregateValuesFilters).map(
        ([title, count]) => ({ title, count })
      );

      const totalCount = options.reduce((acc, curr) => acc + curr.count, 0);
      setSecondaryFilters([
        { title: "All", count: totalCount },
        ...sortOptionsAlphabeticallyOtherLast(options, (o) => o.title),
      ]);
    } else {
      setSecondaryFilters([]); // safe fallback
    }
  }, [aggregateValuesFilters]);

  return (
    <div className="top-listing-header">
      <div className="top-listing-header-top">
        <H2 text={`${PageHeading || ""}`} />
        {ButtonName && <SimpleButton isDisabled={disabled} label={ButtonName} onClick={onClick} />}
      </div>

      <div className="top-listing-header-filters">
        <div className="filter-options">
          {filterOptions?.map((option, index) => (
            <button
              key={index}
              className={`filter-option${activeTab === option.title ? " filter-option-active" : ""
                }`}
              onClick={() => setActiveTab(option.title)}
            >{option.title} ({option.count})
            </button>
          ))}
        </div>
        <div className="search-sort-container">
          <SearchFilterInput
            placeholder="Search By Email"
            searchTerm={searchTerm}
            handleSearch={(e) => setSearchTerm(e.target.value)}
          />
          {!hideSecondaryFilter && (
            <select
              className="select-filters form-select form-control"
              onChange={(e) => handleSelectChange(e.target.value)}
            > {secondaryFilters.map((option) => (
              <option key={option.title} value={option.title}>
                {option.title}
              </option>
            ))}
            </select>
          )}
          {hasWritePermission && (
            <ActionMenu
              menuItems={[
                {
                  label: "Disconnect Account",
                  icon: GetImages.disconnectAccount,
                  action: () => { handleDisconnectClick() },
                },

              ]}
              trigger={
                <button className="action-button" aria-label="More options">
                  <img
                    src={GetImages.dropdownIcon}
                    alt=""
                    width={20}
                    height={20}
                    className="action-icon"
                    loading="lazy"
                  />
                </button>
              }
            />
          )}

          {showConfirmation && (
            <ConfirmationPopup
              isOpen={showConfirmation}
              title="Disconnect Your Account"
              message={`Are you sure you want to disconnect your account?<br/><br/>This email address <b>${connectedEmail || "associated with this account"}</b> will be removed and will no longer be associated with your account.`}
              primaryButtonLabel="Cancel"
              secondaryButtonLabel="Yes, Disconnect Account"
              onPrimaryAction={() => setShowConfirmation(false)}
              onSecondaryAction={handleConfirmDisconnect}
              onClose={() => setShowConfirmation(false)}
              isPrimaryDestructive={true}
            />
          )}
        </div>
      </div>
    </div>
  );
}
